<template>
  <div class="app-view">
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style lang="less">
  h1 {
    color: @color;
  }
  .app-view {
    
    min-height: 100%;
  }
</style>
